import { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon, Typography } from '@scale/scaleui';
import { SearchScope } from '../plugins/scopeSearchPlugin';
import { useMagicSearch } from '../MagicSearchContext';

type SearchResultsListItemScopeProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  scope: SearchScope;
  isFocused?: boolean;
  disableHover?: boolean;
};

export const SearchResultsListItemScope: React.FC<SearchResultsListItemScopeProps> = ({
  className,
  children,
  isFocused,
  disableHover,
  scope,
  ...other
}) => {
  const { onUpdateSearchScope } = useMagicSearch(s => ({
    onUpdateSearchScope: s.onUpdateSearchScope,
  }));

  return (
    <button
      className={twMerge(
        'w-full min-h-14 p-3 py-2 flex items-center',
        !disableHover && 'hover:bg-neutral-100',
        isFocused && 'bg-neutral-100',
        className,
      )}
      {...other}
      onClick={() => onUpdateSearchScope(scope)}
    >
      <div className="flex items-center bg-primary-100 rounded px-3">
        <Typography.Paragraph2 className="text-primary-600">{'in:'}</Typography.Paragraph2>
        <Icon icon={scope.icon} size="md" variant="primary" className="w-6" />
        <Typography.Paragraph2 className="text-primary-600 capitalize">
          {scope.title}
        </Typography.Paragraph2>
      </div>
    </button>
  );
};
